import { Button, Dialog } from 'components/atoms'
import { useBoolean } from 'hooks'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FaTrashAlt } from 'react-icons/fa'
import { ProgramDeleteDialog } from './ProgramDeleteDialog'

export const ProgramDeleteButton: FC<{onDeleted: () => void }> = ({onDeleted}) => {
  const [isModalOpen, toggleModal, closeModal] = useBoolean(false)
  const { t } = useTranslation()

  return (
    <div>
      <Button Icon={<FaTrashAlt />} color="danger" onClick={toggleModal}>
        {t('lot.program.deleteProgram')}
      </Button>
      <Dialog isOpen={isModalOpen} close={closeModal} css={{ width: 500 }}>
        {isModalOpen && <ProgramDeleteDialog onClose={closeModal} onDeleted={onDeleted} />}
      </Dialog>
    </div>
  )
}
